import { z } from "zod";

const irMobileRegex = /^09\d{9}$/;

export const loginFormSchema = z.object({
  username: z
    .string()
    .min(1, { error: "شماره موبایل الزامی است" })
    .regex(irMobileRegex, { error: "شماره موبایل باید با 09 شروع و ۱۱ رقم باشد" }),
  password: z.string().min(1, { error: "رمز عبور الزامی است" }),
  rememberMe: z.boolean(),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;

export const loginSchema = loginFormSchema.pick({
  username: true,
  password: true,
});

const registerFieldsSchema = z.object({
  username: z.string().min(1, { error: "نام کاربری الزامی است" }),
  phone: z
    .string()
    .min(1, { error: "شماره موبایل الزامی است" })
    .regex(irMobileRegex, { error: "شماره موبایل باید با 09 شروع و ۱۱ رقم باشد" }),
  password: z.string().min(8, { error: "رمز عبور باید حداقل ۸ کاراکتر باشد" }),
  repeate_password: z.string().min(1, { error: "تکرار رمز عبور الزامی است" }),
});

const passwordMatchRefine = {
  message: "رمز عبور و تکرار آن یکسان نیستند",
  path: ["repeate_password"],
};

export const registerSchema = registerFieldsSchema.refine(
  (data) => data.password === data.repeate_password,
  passwordMatchRefine,
);

export const registerFormSchema = registerFieldsSchema
  .extend({
    acceptTerms: z.boolean().refine((value) => value, {
      message: "پذیرش قوانین و مقررات الزامی است",
    }),
  })
  .refine((data) => data.password === data.repeate_password, passwordMatchRefine);

export type RegisterFormValues = z.infer<typeof registerFormSchema>;

export const otpPhoneSchema = z.object({
  phone: z
    .string()
    .min(1, { error: "شماره موبایل الزامی است" })
    .regex(irMobileRegex, { error: "شماره موبایل باید با 09 شروع و ۱۱ رقم باشد" }),
});

export type OtpPhoneFormValues = z.infer<typeof otpPhoneSchema>;

export const otpVerifySchema = z.object({
  code: z
    .string()
    .length(5, { error: "کد تأیید باید ۵ رقم باشد" })
    .regex(/^\d{5}$/, { error: "کد تأیید باید ۵ رقم باشد" }),
});

export type OtpVerifyFormValues = z.infer<typeof otpVerifySchema>;
